import * as React from 'react';
import * as RB from 'react-bootstrap';
import { Link, NavLink } from 'react-router-dom';
import { Button, FormGroup, Form, ControlLabel, FormControl, HelpBlock } from 'react-bootstrap';
import * as DTO from '../../service/DTOs';
import * as TF from '../../service/tradeflow';

import * as moment from 'moment';
import 'moment-duration-format';

import * as Intl from 'react-intl'
import Cleave from 'cleave.js/react';
import { AppConfig } from '../../service/AppState'


type CAInstrumentLimitMarginProps = CAInstrumentLimitMarginPropsState & { xsrfToken?: string };

export interface CAInstrumentLimitMarginPropsState {
    instrument: DTO.InstrumentHead;
    //currency: DTO.Currency;
    //duration: DTO.Duration;
    showCurrency: boolean;
    //showDuration: boolean;
    showInstrument: boolean;

    editMargin: boolean;
    compact: boolean;
    twolines: boolean;

    marginpick: DTO.NotesContragentMarginPick,

    warnings?: string;
    errors?: string;

    processMarginChange: (newgivemargin: number | undefined) => void;
    //online?: boolean;
}

export class CAInstrumentLimitMargin extends React.Component<CAInstrumentLimitMarginProps> {

    constructor(props: CAInstrumentLimitMarginProps) {
        super(props);
        //this.handleGiveMarginChange.bind(this);
    }

    submitprocess = (event: React.FormEvent<RB.Form>) => {
         event.preventDefault();
    }

    handleGiveMarginChange = (e: any) => {
        let val: number = e.target.hasOwnProperty('rawValue') ? e.target.rawValue : e.target.value;

        this.props.processMarginChange(val);
    }


    public render() {
        let hdrCaption = undefined;
        if (this.props.showCurrency && this.props.showInstrument)
            hdrCaption = <span className="align-bottom">{this.props.instrument.name}</span>;
        else if (!this.props.showCurrency && this.props.showInstrument)
            hdrCaption = <span className="align-bottom">{this.props.instrument.name}</span>;
        else 
            hdrCaption = undefined;

        let warnMark = null;

        if (this.props.errors != undefined) {
            warnMark = this.props.errors;
        }
        else if (this.props.warnings != undefined) {
            warnMark = this.props.warnings;
        }

        let marginGivenInput = <RB.InputGroup>
            {warnMark}
            <Cleave name="givemargintotal" className="form-control input-numeral" readOnly={!this.props.editMargin} value={this.props.marginpick.givemargin} placeholder="всего"
                options={{ delimiter: AppConfig.locale.thousand_delimiter, numeral: true, numericOnly: true, numeralThousandsGroupStyle: 'thousand', numeralDecimalScale: 0, numeralPositiveOnly: true }}
                onChange={this.handleGiveMarginChange.bind(this)} />
            {!this.props.compact ?
                <RB.InputGroup.Addon>{this.props.instrument.currency.shortname}</RB.InputGroup.Addon>
                : undefined}
        </RB.InputGroup>;

        let marginGivenFree = <RB.InputGroup>
            <Cleave name="givemarginfree" className="form-control input-numeral" readOnly={true} value={this.props.marginpick.free2givedeal} placeholder="свободно"
                options={{ delimiter: AppConfig.locale.thousand_delimiter, numeral: true, numericOnly: true, numeralThousandsGroupStyle: 'thousand', numeralDecimalScale: 0, numeralPositiveOnly: true }}
            />
            {!this.props.compact ?
                <RB.InputGroup.Addon>{this.props.instrument.currency.shortname}</RB.InputGroup.Addon>
                : undefined}
        </RB.InputGroup>;

        let marginGivenInputTitle = !this.props.compact ?
            <RB.Col sm={6 + (this.props.twolines ? 6 : 0)} className='otc-inp-label'>
                {'Total'}
            </RB.Col>
            :
            <RB.Col sm={6 + (this.props.twolines ? 6 : 0)} className='otc-inp-label' >
                <RB.Label>{'Total'} {this.props.instrument.currency.shortname}</RB.Label>
            </RB.Col>;

        let marginGivenFreeTitle = !this.props.compact ?
            <RB.Col sm={6 + (this.props.twolines ? 6 : 0)} className='otc-inp-label'>
                {'Free'}
            </RB.Col>
            :
            <RB.Col sm={6 + (this.props.twolines ? 6 : 0)} className='otc-inp-label'>
                <RB.Label>{'Free'} {this.props.instrument.currency.shortname}</RB.Label>
            </RB.Col>;
    

        
        return <div>
            
            <RB.Form horizontal method="post" onSubmit={this.submitprocess} autoComplete="off">
                <fieldset className={'otc-fieldset'}> 

                    {hdrCaption ?
                        <RB.Row>
                            <RB.FormGroup>
                                <RB.Col sm={12} className='otc-inp-label'>
                                    <span className="align-bottom">{hdrCaption}</span>
                                </RB.Col>
                            </RB.FormGroup>
                        </RB.Row>
                        : undefined}

                    {!this.props.twolines ? <RB.Row>{marginGivenInputTitle}{marginGivenFreeTitle}</RB.Row> : undefined}


                    <RB.Row>
                        {this.props.twolines
                            ?
                            <React.Fragment>
                                <RB.Row>{marginGivenInputTitle}</RB.Row>
                                <RB.Row >
                                    <RB.FormGroup validationState={this.props.errors != undefined ? "error" : (this.props.warnings != undefined ? "warning" : undefined)}>                                
                                        <RB.Col sm={12}>{marginGivenInput}</RB.Col>
                                    </RB.FormGroup>
                                </RB.Row>
                                <RB.Row>{marginGivenFreeTitle}</RB.Row>
                                <RB.Row >
                                    <RB.FormGroup validationState={this.props.errors != undefined ? "error" : (this.props.warnings != undefined ? "warning" : undefined)}>                                
                                        <RB.Col sm={12}>{marginGivenFree}</RB.Col>
                                    </RB.FormGroup>
                                </RB.Row>
                            
                            </React.Fragment>
                            : 
                            <RB.FormGroup validationState={this.props.errors != undefined ? "error" : (this.props.warnings != undefined ? "warning" : undefined)}>
                                    <RB.Col sm={12}>{marginGivenInput}</RB.Col>
                                    <RB.Col sm={12}>{marginGivenFree}</RB.Col>
                            </RB.FormGroup>
                            }
                    </RB.Row>

                    
                            </fieldset>
                        </RB.Form>
        </div>
    }
}

